import splide from "../utils/splide";
require('fslightbox');

const gallery = document.getElementById("gallery");
if(gallery) {
  const splideGallery = splide(gallery, {
    perPage: 3,
    arrows: true,
    pagination: false,
  })
  splideGallery.mount()
}
